import { __decorate } from "tslib";
import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import { PortraitListShowEnum } from '@blade-sxp/portrait-management/interfaces/common';
import store from '@blade/common/store';
import { automobileTypeOrColor, } from '@blade-sxp/portrait-management/api/vehicle';
const Service = {
    automobileTypeOrColor
};
const setMatValue = (tree) => {
    const dataMap = {};
    const deepTree = (tree) => {
        tree?.forEach((item) => {
            if (item.children && item.children.length > 0) {
                deepTree(item.children);
            }
            dataMap[item.value] = item.name;
        });
    };
    deepTree(tree);
    return dataMap;
};
const clearEmptyArray = (tree) => {
    return tree.map((item) => {
        if (item.children && item.children.length > 0) {
            clearEmptyArray(item.children);
        }
        else {
            delete item.children;
        }
        return item;
    });
};
let PortraitManagementData = class PortraitManagementData extends VuexModule {
    // 人像库/车辆库的切换标签
    portraitLibActiveTab = '';
    // 人像卡片/列表展示模式
    portraitViewModeType = PortraitListShowEnum.LIST;
    // 人像是否批量选择
    portraitIsBatchOperation = false;
    // 人像选择
    portraitSelectionList = [];
    vehicleTypeColorMap = {};
    vehicleTypeColorDataListMap = {};
    setPortraitLibActiveTab(val) {
        this.portraitLibActiveTab = val;
    }
    setPortraitViewModeType(val) {
        this.portraitViewModeType = val;
    }
    setPortraitIsBatchOperation(val) {
        this.portraitIsBatchOperation = val;
    }
    setPortraitSelectionList(val) {
        this.portraitSelectionList = val;
    }
    setMapData(res) {
        const { data = [], filterType } = res || {};
        this.vehicleTypeColorDataListMap[filterType] = clearEmptyArray(data) || {};
        this.vehicleTypeColorMap[filterType] = setMatValue(data) || {};
    }
    async getAutomobileTypeOrColor(filterType) {
        const param = {
            filterType,
        };
        try {
            const res = await Service.automobileTypeOrColor(param);
            if (res)
                this.setMapData({ data: res, filterType });
        }
        catch (error) {
            throw (error);
        }
    }
};
__decorate([
    Mutation
], PortraitManagementData.prototype, "setPortraitLibActiveTab", null);
__decorate([
    Mutation
], PortraitManagementData.prototype, "setPortraitViewModeType", null);
__decorate([
    Mutation
], PortraitManagementData.prototype, "setPortraitIsBatchOperation", null);
__decorate([
    Mutation
], PortraitManagementData.prototype, "setPortraitSelectionList", null);
__decorate([
    Mutation
], PortraitManagementData.prototype, "setMapData", null);
__decorate([
    Action({ rawError: true })
], PortraitManagementData.prototype, "getAutomobileTypeOrColor", null);
PortraitManagementData = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/PortraitManagementData' })
], PortraitManagementData);
export const PortraitManagementDataModule = getModule(PortraitManagementData);
